export const SET_PET_WEATHER_DATA = 'SET_PET_WEATHER_DATA'
export const SET_PET_WALKING_SUMMARY_DATA = 'SET_PET_WALKING_SUMMARY_DATA'
export const SET_PET_WALKING_HISTORY_DATA = 'SET_PET_WALKING_HISTORY_DATA'
export const SET_PET_SUMMARY_DATA = 'SET_PET_SUMMARY_DATA'
export const SET_PET_INFO_DATA = 'SET_PET_INFO_DATA'
